import { ChangeLogResources } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/components/ChangeLogResource';
import { LogisticsResourceType } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';

type ChangeLogResourceItemProps = {
  resource: LogisticsResourceType;
};

export const ChangeLogResourceItem = ({ resource }: ChangeLogResourceItemProps) => {
  const getResourceItem = () => {
    switch (resource.resourceType) {
      case CaseResourceType.ClinicalSpecialist:
        return (
          <ChangeLogResources
            type={resource.resourceType}
            title={`${getFullName(resource.firstName, resource.lastName)} (CS)`}
            photoPath={resource.photoPath}
          />
        );
      case CaseResourceType.Surgeon:
        return (
          <ChangeLogResources
            type={resource.resourceType}
            title={`${getFullName(resource.firstName, resource.lastName)} (RS)`}
            photoPath={resource.photoPath}
          />
        );
      case CaseResourceType.OCSConsole:
        return <ChangeLogResources type={resource.resourceType} title={resource.fullSerialNumber} />;
      case CaseResourceType.Crew:
        return (
          <ChangeLogResources
            type={resource.resourceType}
            title={`${getFullName(resource.firstName, resource.lastName)} (TMDX Pilot)`}
          />
        );
      default:
        return null;
    }
  };

  return <>{getResourceItem()}</>;
};
